// We need EventManager to be available on the window object (so it can be used like `window.EventManager.on()...`).
// Some GVP components require this, and our Webpack build is configured to require this as well.
//
// However, node_modules/@shop/lib-eventmanager/dist/event-manager.js sets window.EventManager
// to be the event-manager module, rather than EventManager itself.  EventManager is available
// on the `default` property of this module.  So this script fixes the import.
if (window.EventManager && !window.EventManager.on && window.EventManager.default) {
    window.EventManager = window.EventManager.default;
}
